import React from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { storeTypes } from 'shared/reducer';
import Header from 'components/header';
import Loading from 'components/loading';

import style from './style.module.scss';

const Layout = ({
  children,
  props: {
    pageContext: { isHeaderSticky },
  },
}) => {
  const isLoading = useSelector((state: storeTypes) => state.isLoading);
  return (
    <div className={style.layout}>
      <Header isSticky={isHeaderSticky} />
      {isLoading && <Loading />}
      {children}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default Layout;
